/**
 * @license
 * This Source Code Is Written By Aoun Alazzam Under MIT License
 */

import { Banner } from "./Banner";
import { Products } from "./Products";

function MainPage() {
  return (
    <>
      <Banner />
      <Products />
    </>
  );
}

export { MainPage };
